import React from 'react';
import { Person } from '../graph/types';

interface AttendeeChipProps {
  person: Person;
  onRemove: (person: Person) => void;
}

export const AttendeeChip: React.FC<AttendeeChipProps> = ({ person, onRemove }) => {
  return (
    <div className="attendee-chip">
      <span className="attendee-name">{person.displayName}</span>
      <span className="attendee-email">{person.emailAddress}</span>
      <button
        className="remove-btn"
        onClick={() => onRemove(person)}
        aria-label={`Remove ${person.displayName}`}
      >
        ×
      </button>
    </div>
  );
};
